import { css } from 'emotion'

export const NewTaskFormStyles = css`
  .TextAreaInput {
    min-height: 68px;
  }
`
